/* eslint-disable @typescript-eslint/no-explicit-any */

import defaultAppState from '../../defaultAppState';

import { ElmPortName } from 'state/service/appTs/types';
import { assign } from 'es-toolkit/compat';
import settings from 'settings/AppSettings';

const partyShape = {
  id: -1,
  arrivalTime: null,
  bookingNote: '',
  purchase: null,
  experience: '',
  expectedPartySize: 0,
  expectedReservationTime: null,
  leftTime: null,
  notesContainer: {
    bookingNote: [],
    dietaryNote: [],
    patronNote: [],
  },
  numPeoplePresent: 0,
  primaryDiner: {
    email: null,
    firstName: null,
    lastName: null,
    phone: null,
    patronId: null,
    patronNote: '',
    dietaryNote: '',
  },
  seatedTime: null,
  shortNotes: '', // DEPRECATED
  state: 'EXPECTED',
  tag: [],
};

const tableShape = {
  id: -1,
  name: '',
  section: '',
  size: -1,
  state: 'Ready', // Ready|Seated|Blocked|Dirty
};

const businessShape = {
  id: -1,
  businessGroupId: -1,
  name: '',
  locale: '',
};

// Keys are port names, values are the shape of the message.
const jsToElmPorts: { [T in ElmPortName]: any } = {
  assignBusinessServerToTable: '',
  cutServer: '',
  removeServer: '',
  addServerWithName: '',
  addExtraTableToParty: { party: partyShape, table: tableShape, timestamp: -1 },
  addMultipleExtraTablesToParty: { partyId: -1, tableIds: [] },
  addWalkInParty: {},
  clearError: [],
  displayError: '',
  initialAppState: defaultAppState,
  fetchMoreHistory: {},
  fetchHistoryFailed: {},
  markHistoryItemsAsRead: [],
  markTextMessagesAsRead: { partyId: -1 },
  moveTable: { tableId: -1, newPosition: { xPosition: -1, yPosition: -1 } },
  receiveHistory: {},
  removeServerWithName: '',
  removePartyFromTable: { party: partyShape, table: tableShape, timestamp: -1 },
  removeWalkInParty: { partyId: -1 },
  replaceTablesForParty: { partyId: -1, tableId: -1 },
  requestCurrentModel: [],
  resetTablePositions: [],
  seatWalkInParty: { walkInPartyDescription: {}, tableId: -1, timestamp: -1 },
  sendChatMessage: { text: '' },
  serverBaseUrl: settings.API_BASE,
  setHistoryToggledOn: false,
  setHistoryLatestEventId: -1,
  setIsReadOnly: false,
  setTopic: {
    newTopic: { selectedBusiness: businessShape, serviceDate: '' },
  },
  updateParty: { party: partyShape, updateType: '', newValue: '', timestamp: -1 },
  updatePartyState: { party: partyShape, state: 'expected', timestamp: -1 },
  updateTableState: { tableId: -1, newState: 'Ready' },

  // Websocket input port
  inboundWebsocketMessage: '',
  // Websocket acknowledgement port
  inboundMessageAcknowledgement: null,
};

export { partyShape };

export function getInitialJSToElmPortValues(initialAppState: any) {
  return assign({}, jsToElmPorts, { initialAppState });
}

export default jsToElmPorts;
